<template>
  <div class="text-divider">
    <span>
      <slot />
    </span>
  </div>
</template>

<style scoped>
.text-divider {
  --divider-stroke: var(--stroke-color);
  --divider-color: var(--zinc-400);
  --divider-background: var(--fill-1);
  --divider-margin-start: 2rem;
  --divider-margin-end: 2rem;

  display: flex;
  justify-content: center;
  position: relative;
  isolation: isolate;
  margin-block-start: var(--divider-margin-start);
  margin-block-end: var(--divider-margin-end);

  color: var(--divider-color);

  font-size: 0.625rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
}

.text-divider::after {
  content: '';
  display: flex;
  position: absolute;
  left: 0;
  top: 50%;
  z-index: -1;
  height: 1px;
  width: 100%;

  background: var(--stroke-color);
}

.text-divider > * {
  padding-inline: 0.88rem;
  background: var(--fill-1);
}
</style>
